import React from 'react';
import { Section } from './ui/Section';
import { Quote } from 'lucide-react';
export function Proof() {
  return <Section className="bg-cream-dark/50 border-y border-gold/10" data-id="element-140">
      <div className="max-w-3xl mx-auto text-center" data-id="element-141">
        <Quote className="w-12 h-12 text-gold/40 mx-auto mb-8" data-id="element-142" />

        <p className="text-xl md:text-2xl font-light leading-relaxed text-charcoal mb-8" data-id="element-143">
          En solo 7 días tras aplicar el Protocolo de Presencia Silenciosa,
          dejarás de preguntarte "qué pensarán mis conocidos" y empezarás a
          recibir comentarios de{' '}
          <strong className="font-medium text-navy" data-id="element-144">
            "gracias por hablar con tanta claridad"
          </strong>
          .
        </p>

        <p className="text-lg text-charcoal-light font-light" data-id="element-145">
          No buscamos viralidad vacía; buscamos que tu cliente ideal piense:{' '}
          <br data-id="element-146" />
          <span className="italic font-serif text-xl text-navy mt-4 block" data-id="element-147">
            “Ella sabe de lo que habla, quiero trabajar con ella”.
          </span>
        </p>
      </div>
    </Section>;
}